import { Link, useLocation } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const { pathname } = useLocation();

  const handleLinkClick = (path) => {
    if (pathname === path) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };
  
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <h5>Roriri ERP</h5>
          <p>Empowering schools worldwide with innovative cloud-based ERP solutions.</p>
        </div>
        
        <div className="footer-column">
          <h6>About Product</h6>
          <ul className="footer-links-list">
            <li>
              <Link to="/features" onClick={() => handleLinkClick('/features')} className="footer-link-item">Features</Link>
            </li>
            <li>
              <Link to="/pricing" onClick={() => handleLinkClick('/pricing')} className="footer-link-item">Pricing</Link>
            </li>
          </ul>
        </div>
        
        <div className="footer-column">
          <h6>Support</h6>
          <ul className="footer-links-list">
            <li>
              <Link to="/faq" onClick={() => handleLinkClick('/faq')} className="footer-link-item">FAQ</Link>
            </li>
            <li>
              <Link to="/contact" onClick={() => handleLinkClick('/contact')} className="footer-link-item">Contact Us</Link>
            </li>
          </ul>
        </div>
        
        <div className="footer-column">
          <h6>Legal</h6>
          <ul className="footer-links-list">
            <li>
              <Link to="/terms" onClick={() => handleLinkClick('/terms')} className="footer-link-item">Terms & Conditions</Link>
            </li>
            <li>
              <Link to="/privacy" onClick={() => handleLinkClick('/privacy')} className="footer-link-item">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/refund" onClick={() => handleLinkClick('/refund')} className="footer-link-item">Refund Policy</Link>
            </li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div>© {currentYear} Roriri. All rights reserved.</div>
      </div>
    </footer>
  );
}
